import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import IsLogin from "../../../Common/IsLogin";
import Swal from "sweetalert2";

const Show = () => {
  const [receiveData, setReceiveData] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState({});
  const [alert, setAlert] = useState(null);
  const location = useLocation();

  const fetchData = () => {
    Http.get("/others-receive/" + id).then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  useEffect(() => {
    if (!location.state) {
      return;
    }
    showAlert(location.state.message, location.state.type);
  }, [location]);

  const receiveWorkOrder = (id, deleteApiUrl, showMsg) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You wan't to create an Purchase Order based on this quotation!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Create Purchase Order!",
    }).then((result) => {
      if (result.isConfirmed) {
        inputs.circular_rfq_id = id;
        inputs.work_order_id = receiveData.id;
        inputs.work_order_items_id = receiveData.items;

        Http.post("/create-purchase-order/", inputs)
          .then((res) => {
            Swal.fire("Purchase Order! has been Created.", "success");
            navigate("/final-quotation", {
              state: { message: res.data.message, type: "success" },
            });
          })
          .catch(function (e) {
            setError(e.response.data.errors);
          });
      }
    });
  };

  const print = () => {
    window.print();
  };

  // Calculate totals
  const calculateTotals = () => {
    if (!receiveData.items)
      return {
        totalPrice: 0,
        totalDeduction: 0,
        grandTotal: 0,
        finalPayable: 0,
      };

    const totalPrice = receiveData.items.reduce((total, item) => {
      const subtotal =
        (parseFloat(item.qty) || 0) * (parseFloat(item.unit_price) || 0);
      return total + subtotal;
    }, 0);

    const totalDeduction = receiveData.items.reduce((total, item) => {
      const deductionSubtotal =
        (parseFloat(item.damage_qty) || 0) * (parseFloat(item.deduction) || 0);
      return total + deductionSubtotal;
    }, 0);

    const grandTotal = totalPrice + totalDeduction;
    const discount = parseFloat(receiveData.discount) || 0;
    const otherExpenses = parseFloat(receiveData.other_expense) || 0;
    const finalPayable = grandTotal - discount + otherExpenses;

    return { totalPrice, totalDeduction, grandTotal, finalPayable };
  };

  const totals = calculateTotals();

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <style>
        {`
          @media print {
            @page {
              margin: 15mm;
            }
            body * { visibility: hidden; }
            .no-print, .noPrint { display: none !important; visibility: hidden !important; }
            #printable-content, #printable-content * { visibility: visible; }
            #printable-content { 
              position: absolute; 
              left: 0; 
              top: 0; 
              width: 100%; 
              padding: 0;
              margin: 0;
            }
            .card { 
              box-shadow: none !important; 
              border: none !important; 
              padding: 0 !important; 
              margin: 0 !important;
            }
            .card-body { padding: 0 !important; margin: 0 !important; }
            .print-logo { margin-bottom: 20px !important; }
            .print-logo img { max-width: 200px !important; }
            
            /* Print Info Section */
            .print-info-section {
              border: 2px solid #000 !important;
              padding: 12px !important;
              margin-bottom: 15px !important;
              background: #f8f9fa !important;
            }
            .print-info-title {
              font-size: 12px !important;
              font-weight: bold !important;
              text-transform: uppercase !important;
              margin-bottom: 10px !important;
              border-bottom: 1px solid #000 !important;
              padding-bottom: 5px !important;
            }
            .print-info-row {
              display: flex !important;
              margin-bottom: 6px !important;
            }
            .print-info-label {
              font-size: 10px !important;
              font-weight: bold !important;
              text-transform: uppercase !important;
              width: 120px !important;
              display: inline-block !important;
            }
            .print-info-value {
              font-size: 10px !important;
              flex: 1 !important;
            }
            
            /* Print Table */
            .print-table-section {
              margin-bottom: 20px !important;
            }
            .print-items-title {
              font-size: 12px !important;
              font-weight: bold !important;
              text-transform: uppercase !important;
              margin-bottom: 10px !important;
              border-bottom: 2px solid #000 !important;
              padding-bottom: 5px !important;
            }
            table { 
              font-size: 9px !important;
              border-collapse: collapse !important;
              width: 100% !important;
            }
            table th { 
              padding: 8px 4px !important; 
              font-size: 9px !important;
              font-weight: bold !important;
              border: 1px solid #000 !important;
              background: #e9ecef !important;
              text-transform: uppercase !important;
            }
            table td { 
              padding: 6px 4px !important;
              font-size: 9px !important;
              border: 1px solid #000 !important;
            }
            table tfoot td {
              font-weight: bold !important;
              background: #f8f9fa !important;
            }
            .total-row { background: #e9ecef !important; }
            .discount-row { background: #fee !important; }
            .final-row { 
              background: #d4edda !important;
              font-size: 11px !important;
            }
            
            /* Hide elements */
            .section-wrapper { 
              border: none !important; 
              padding: 0 !important; 
              margin: 0 !important;
            }
            .section-title { display: none !important; }
            .web-only { display: none !important; }
          }
          .info-group { margin-bottom: 8px; }
          .section-wrapper { border: 1px solid #e3e7ed; border-radius: 3px; padding: 15px; }
          .print-only { display: none; }
          @media print {
            .print-only { display: block !important; }
          }
        `}
      </style>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle no-print noPrint">
            <h5 className="am-title">Direct Purchase Details</h5>
            {/* <div className="am-breadcrumb">
              <span>
                <Link to="/">Home</Link>
              </span>
              <span>
                <Link to="/others-receive">Direct Purchase</Link>
              </span>
              <span className="active">View Details</span>
            </div> */}
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card pd-20 pd-sm-40" id="printable-content">
              {/* Header with Actions */}
              <div className="card-header bg-gray-200 pd-y-20 d-flex align-items-center justify-content-between noPrint">
                <h6 className="tx-uppercase tx-bold tx-spacing-1 mg-b-0">
                  Direct Purchase - {receiveData.receipt_no}
                </h6>
                <div>
                  <button
                    className="btn btn-primary btn-sm mg-r-5"
                    onClick={print}
                  >
                    <i className="fa fa-print"></i> Print
                  </button>
                  {/* <Link
                    to="/others-receive"
                    className="btn btn-secondary btn-sm"
                  >
                    <i className="icon ion-arrow-left-c"></i> Back to List
                  </Link> */}
                </div>
              </div>

              <div className="card-body pd-30">
                {/* Logo Section */}
                <div className="row mg-b-20 print-logo text-center">
                  <div className="col-12">
                    <img
                      src="/assets/img/logo.jpg"
                      style={{ maxWidth: "200px" }}
                      alt="Company Logo"
                    />
                  </div>
                </div>

                {/* Print-only styled info section */}
                <div className="print-only print-info-section">
                  <div className="print-info-title">RECEIVE INFORMATION</div>
                  <div className="row">
                    <div className="col-6">
                      <div className="print-info-row">
                        <span className="print-info-label">Receipt No</span>
                        <span className="print-info-value">
                          {receiveData.receipt_no || "N/A"}
                        </span>
                      </div>
                      <div className="print-info-row">
                        <span className="print-info-label">Date</span>
                        <span className="print-info-value">
                          {receiveData.date || "N/A"}
                        </span>
                      </div>
                      <div className="print-info-row">
                        <span className="print-info-label">Bill No</span>
                        <span className="print-info-value">
                          {receiveData.bill_no || "N/A"}
                        </span>
                      </div>
                      <div className="print-info-row">
                        <span className="print-info-label">Vendor</span>
                        <span className="print-info-value">
                          {receiveData.vendor?.name || "N/A"}
                        </span>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="print-info-row">
                        <span className="print-info-label">Factory</span>
                        <span className="print-info-value">
                          {receiveData.factory?.name || "N/A"}
                        </span>
                      </div>
                      <div className="print-info-row">
                        <span className="print-info-label">Created By</span>
                        <span className="print-info-value">
                          {receiveData.created_by?.name || "N/A"}
                        </span>
                      </div>
                      {receiveData.department_id && (
                        <div className="print-info-row">
                          <span className="print-info-label">Department</span>
                          <span className="print-info-value">
                            {receiveData.department?.name || "N/A"}
                          </span>
                        </div>
                      )}
                      {receiveData.description && (
                        <div className="print-info-row">
                          <span className="print-info-label">Description</span>
                          <span className="print-info-value">
                            {receiveData.description}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {/* Basic Information Section - Web View Only */}
                <div className="row mg-b-25 web-only">
                  <div className="col-lg-12">
                    <div className="section-wrapper bd bd-gray-300 rounded">
                      <label className="section-title tx-uppercase tx-bold tx-spacing-1 tx-11 tx-gray-600 mg-b-15">
                        Receive Information
                      </label>
                      <div className="row">
                        <div className="col-md-4 col-lg-3">
                          <div className="info-group">
                            <label className="tx-9 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                              Receipt No
                            </label>
                            <p className="tx-13 tx-semibold tx-primary mg-b-0">
                              {receiveData.receipt_no || "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3">
                          <div className="info-group">
                            <label className="tx-9 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                              Date
                            </label>
                            <p className="tx-13 tx-semibold tx-gray-800 mg-b-0">
                              {receiveData.date || "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3">
                          <div className="info-group">
                            <label className="tx-9 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                              Bill No
                            </label>
                            <p className="tx-13 tx-semibold tx-gray-800 mg-b-0">
                              {receiveData.bill_no || "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3">
                          <div className="info-group">
                            <label className="tx-9 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                              Vendor
                            </label>
                            <p className="tx-13 tx-semibold tx-gray-800 mg-b-0">
                              {receiveData.vendor?.name || "N/A"}
                            </p>
                          </div>
                        </div>
                        <div className="col-md-4 col-lg-3">
                          <div className="info-group">
                            <label className="tx-9 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                              Factory
                            </label>
                            <p className="tx-13 tx-semibold tx-gray-800 mg-b-0">
                              {receiveData.factory?.name || "N/A"}
                            </p>
                          </div>
                        </div>
                        {receiveData.department_id && (
                          <div className="col-md-4 col-lg-3">
                            <div className="info-group">
                              <label className="tx-9 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                                Department
                              </label>
                              <p className="tx-13 tx-semibold tx-gray-800 mg-b-0">
                                {receiveData.department?.name || "N/A"}
                              </p>
                            </div>
                          </div>
                        )}
                        <div className="col-md-4 col-lg-3">
                          <div className="info-group">
                            <label className="tx-9 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                              Created By
                            </label>
                            <p className="tx-13 tx-semibold tx-gray-800 mg-b-0">
                              {receiveData.created_by?.name || "N/A"}
                            </p>
                          </div>
                        </div>
                        {receiveData.description && (
                          <div className="col-md-12">
                            <div className="info-group">
                              <label className="tx-9 tx-uppercase tx-medium tx-spacing-1 tx-gray-600">
                                Description
                              </label>
                              <p className="tx-13 tx-gray-800 mg-b-0">
                                {receiveData.description}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Items Table Section */}
                <div className="row mg-b-30 print-table-section">
                  <div className="col-lg-12">
                    <div className="section-wrapper">
                      <label className="section-title tx-uppercase tx-bold tx-spacing-1 tx-11 tx-gray-600 mg-b-15 web-only">
                        Received Items
                      </label>
                      <div className="print-only print-items-title">
                        RECEIVED ITEMS
                      </div>
                      <div className="table-responsive">
                        <table className="table table-bordered mg-b-0 tx-13">
                          <thead className="thead-light">
                            <tr>
                              <th className="text-center wd-3p">#</th>
                              <th className="wd-20p">PRODUCT</th>
                              <th className="text-right wd-7p">QTY</th>
                              <th className="text-right wd-8p">PRICE</th>
                              <th className="text-right wd-9p">SUBTOTAL</th>
                              <th className="text-right wd-7p">DAMAGE QTY</th>
                              <th className="text-right wd-8p">DEDUCTION</th>
                              <th className="text-right wd-9p">DED. TOTAL</th>
                              <th className="text-right wd-9p">FINAL PRICE</th>
                              <th className="wd-13p">DESCRIPTION</th>
                            </tr>
                          </thead>
                          <tbody>
                            {receiveData.items &&
                            receiveData.items.length > 0 ? (
                              receiveData.items.map((item, index) => (
                                <tr key={item.id}>
                                  <td className="text-center">{index + 1}</td>
                                  <td className="tx-medium tx-gray-800">
                                    {item.product?.name || "N/A"}
                                  </td>
                                  <td className="text-right">
                                    {(parseFloat(item.qty) || 0).toFixed(2)}
                                  </td>
                                  <td className="text-right">
                                    {(parseFloat(item.unit_price) || 0).toFixed(
                                      2
                                    )}
                                  </td>
                                  <td className="text-right tx-semibold">
                                    {(
                                      (parseFloat(item.qty) || 0) *
                                      (parseFloat(item.unit_price) || 0)
                                    ).toFixed(2)}
                                  </td>
                                  <td className="text-right tx-danger">
                                    {item.damage_qty ?? 0}
                                  </td>
                                  <td className="text-right tx-danger">
                                    {(parseFloat(item.deduction) || 0).toFixed(
                                      2
                                    )}
                                  </td>
                                  <td className="text-right tx-semibold tx-danger">
                                    {(
                                      (parseFloat(item.damage_qty) || 0) *
                                      (parseFloat(item.deduction) || 0)
                                    ).toFixed(2)}
                                  </td>
                                  <td className="text-right tx-semibold tx-success">
                                    {(
                                      (parseFloat(item.qty) || 0) *
                                        (parseFloat(item.unit_price) || 0) +
                                      (parseFloat(item.damage_qty) || 0) *
                                        (parseFloat(item.deduction) || 0)
                                    ).toFixed(2)}
                                  </td>
                                  <td className="tx-11">{item.desc || "-"}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan="10"
                                  className="text-center pd-20 tx-gray-500"
                                >
                                  No items found
                                </td>
                              </tr>
                            )}
                          </tbody>
                          <tfoot className="bg-gray-100">
                            <tr className="total-row">
                              <td
                                colSpan="4"
                                className="text-right tx-medium tx-uppercase tx-11"
                              >
                                TOTAL PRICE:
                              </td>
                              <td className="text-right tx-semibold tx-15">
                                {totals.totalPrice.toFixed(2)}
                              </td>
                              <td colSpan="2"></td>
                              <td className="text-right tx-semibold tx-danger tx-15">
                                {totals.totalDeduction.toFixed(2)}
                              </td>
                              <td className="text-right tx-bold tx-success tx-15">
                                {totals.grandTotal.toFixed(2)}
                              </td>
                              <td></td>
                            </tr>
                            <tr className="bg-gray-200 discount-row">
                              <td
                                colSpan="8"
                                className="text-right tx-medium tx-uppercase tx-11 tx-danger"
                              >
                                DISCOUNT AMOUNT:
                              </td>
                              <td className="text-right tx-semibold tx-danger tx-15">
                                {(
                                  parseFloat(receiveData.discount) || 0
                                ).toFixed(2)}
                              </td>
                              <td></td>
                            </tr>
                             <tr className="bg-gray-200 discount-row">
                              <td
                                colSpan="8"
                                className="text-right tx-medium tx-uppercase tx-11 tx-danger"
                              >
                                OTHER EXPENSES:
                              </td>
                              <td className="text-right tx-semibold tx-danger tx-15">
                                {(
                                  parseFloat(receiveData.other_expense) || 0
                                ).toFixed(2)}
                              </td>
                              <td></td>
                            </tr>
                            <tr className="bg-success tx-white final-row">
                              <td
                                colSpan="8"
                                className="text-right tx-bold tx-uppercase tx-13"
                              >
                                TOTAL PAYABLE AMOUNT:
                              </td>
                              <td className="text-right tx-bold tx-18">
                                {totals.finalPayable.toFixed(2)}
                              </td>
                              <td></td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Summary Card */}
                <div className="row noPrint">
                  <div className="col-lg-6 offset-lg-6">
                    <div className="card bd bd-gray-400">
                      <div className="card-header bg-gray-200 pd-15">
                        <h6 className="tx-uppercase tx-bold tx-12 mg-b-0">
                          Payment Summary
                        </h6>
                      </div>
                      <div className="card-body pd-20">
                        <div className="d-flex justify-content-between mg-b-10">
                          <span className="tx-medium">Subtotal:</span>
                          <span className="tx-semibold">
                            {totals.totalPrice.toFixed(2)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mg-b-10">
                          <span className="tx-medium">Deduction Total:</span>
                          <span className="tx-semibold tx-danger">
                            +{totals.totalDeduction.toFixed(2)}
                          </span>
                        </div>
                        <div className="d-flex justify-content-between mg-b-10">
                          <span className="tx-medium">Discount:</span>
                          <span className="tx-semibold tx-danger">
                            -
                            {(parseFloat(receiveData.discount) || 0).toFixed(2)}
                          </span>
                        </div>
                         <div className="d-flex justify-content-between mg-b-10">
                          <span className="tx-medium">Other Expenses:</span>
                          <span className="tx-semibold tx-danger">
                            +
                            {(parseFloat(receiveData.other_expense) || 0).toFixed(2)}
                          </span>
                        </div>
                        <div className="bd-t bd-gray-300 mg-t-15 pd-t-15">
                          <div className="d-flex justify-content-between">
                            <span className="tx-bold tx-16">
                              Final Payable:
                            </span>
                            <span className="tx-bold tx-success tx-18">
                              {totals.finalPayable.toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Show;